import { ExternalLink } from "@octopusdeploy/design-system-components";
import { OverviewContainer, OverviewHighlightText } from "./CommonViews";
export const CommonLibraryRetentionPoliciesOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="RetentionPolicies">Retention policies</ExternalLink> dictate how long releases, deployments, packages, and runbook runs are kept for. Octopus Deploy provides centralized management of retention policies to help
                    you preserve important data while also optimizing storage usage.
                </p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
